/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import { types } from 'mobx-state-tree';

export default types
	.model('SlotPlaceholderStateModel', {
		activePlaceholderExists: types.optional(types.boolean, false)
	})
	.views((self) => ({
		/**
		 * @return {boolean} activePlaceholderExists
		 */
		getActivePlaceholderExists() {
			return self.activePlaceholderExists;
		}
	}))
	.actions((self) => {
		return {
			setActivePlaceholderExists(activePlaceholderExists) {
				self.activePlaceholderExists = activePlaceholderExists;
			}
		};
	});



// WEBPACK FOOTER //
// ./src/js/models/SlotPlaceholderStateModel.js